<template>
  <div id="app">
    <div class="appHeader">
      <div class="header">
        <img class="close-img" :src="closeImage" alt="" @click="goBack" />
        {{ $t("RedemptionCodePage.RedemptionCode") }}
        <!-- <img class="share-img" :src="shareImage" alt="" /> -->
        <!-- <img class="fanyi-img" :src="fanyiImage" alt="" @click="handleLanguage" /> -->
        <div class="fanyi-img" @click="handleLanguage">
          {{ langText }}
        </div>
      </div>
    </div>
    <div class="title">
      <div class="title-left">
        <div>{{ $t("RedemptionCodePage.ValueAddedServices") }}</div>
        <div class="describe">
          {{ $t("RedemptionCodePage.UpgradedExperience") }}
        </div>
      </div>
      <div class="title-right" @click="hanldeUserCodes">
        <img class="person-img" :src="personImage" alt="" />
      </div>
    </div>
    <div class="tip" :style="{ height: height1 }">
      <img class="title-img" :src="titleImage" alt="" />
    </div>

    <div :style="{overflowY: 'auto',height:serviceHeight}">
      <div
      :class="{ 'fanyi-service': true, isActive: active }"
      :style="{ height: height2 }"
      @click="handleItem('fanyi')"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="offlineImage" alt="" />
          {{ $t("RedemptionCodePage.OfflineTranslation") }}
        </div>
        <div class="item2">{{ $t("RedemptionCodePage.NoInternet") }}</div>
        <div class="item3" :style="{ width: width1 }">
          <span style="padding-right: 16px">{{
            $t("RedemptionCodePage.GoToSubscribe")
          }}</span>
          <img class="right-img" :src="rightImage" alt="" />
        </div>
      </div>
      <div class="fanyi-service-right">
        <div class="right-item1">
          <img class="icon-right-img" :src="iconRightImage" alt="" />
        </div>
        <div>
          <img class="scan-img" :src="scanImage" alt="" />
        </div>
      </div>
    </div>
    <div
      v-if="showVideoService"
      class="video-service"
      @click="handleItem('video')"
      :style="{ height: height3 }"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="iconShipinImage" alt="" />
          {{ $t("RedemptionCodePage.AudioAndVideoCall") }}
        </div>
        <div class="item2">{{ $t("RedemptionCodePage.RealTimeCall") }}</div>
        <div class="item3" :style="{ width: width1 }">
          <span style="padding-right: 16px">{{
            $t("RedemptionCodePage.GoToSubscribe")
          }}</span>
          <img class="right-img" :src="rightImage" alt="" />
        </div>
      </div>
      <div class="fanyi-service-right">
        <div class="right-item1">
          <img class="icon-right-img" :src="iconRightImage" alt="" />
        </div>
        <div>
          <img class="scan-img" :src="scanImage" alt="" />
        </div>
      </div>
    </div>
    <div
      class="base-service"
      @click="handleItem('base')"
      v-if="show"
      :style="{ height: height4 }"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="baseImage" alt="" />
          {{ $t("RedemptionCodePage.BaseService") }}
        </div>
        <div class="item2">{{ $t("RedemptionCodePage.AIAssistant") }}</div>
        <div class="item3" :style="{ width: width1 }">
          <span style="padding-right: 16px">{{
            $t("RedemptionCodePage.GoToSubscribe")
          }}</span>
          <img class="right-img" :src="rightImage" alt="" />
        </div>
      </div>
      <div class="fanyi-service-right">
        <div class="right-item1">
          <img class="icon-right-img" :src="iconRightImage" alt="" />
        </div>
        <div>
          <img class="scan-img" :src="scanImage" alt="" />
        </div>
      </div>
    </div>
    </div>
    
    <!-- <div style="height: 24px"></div> -->
    <div class="drawer">
      <el-drawer
        :title="$t('RedemptionCodePage.LanguagesSetting')"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="65%"
        :wrapperClosable="false"
      >
        <div class="drawer-item">
          <div
            class="drawer-content"
            v-for="item in langs"
            :key="item.id"
            @click="setLang(item)"
          >
            <div v-if="item.check">
              <img class="checked-img" :src="checkedImage" alt="" />
            </div>
            <div v-else class="checked-img"></div>
            <div>
              <span class="item-left">{{ item.name }}</span>
              <span class="item-right">{{ item.describe }}</span>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
  
  <script>
import { getToken } from "@/utils/auth";
export default {
  name: "RedemptionPage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      serviceHeight:'',
      showVideoService:true,
      devices: [],
      goodsGroup: [],
      show1: false,
      OffLinePrice: "",
      langText: "ZH",
      width1: "88px",
      height1: "220px",
      height2: "136px",
      height3: "136px",
      height4: "136px",
      isLogin: false,
      show: true,
      langs1: [
        {
          name: "简体中文",
          describe: "简体中文",
          id: 1,
          check: true,
          value: "cn",
        },
        {
          name: "繁體中文",
          describe: "繁体中文",
          id: 2,
          check: false,
          value: "tw",
        },
        {
          name: "English",
          describe: "英文",
          id: 3,
          check: false,
          value: "en",
        },
        {
          name: "日本語",
          describe: "日语",
          id: 4,
          value: "ja",
          check: false,
        },
        {
          name: "한국어",
          describe: "韩语",
          id: 5,
          value: "ko",
          check: false,
        },
        {
          name: "Русский",
          describe: "俄语",
          id: 6,
          value: "ru",
          check: false,
        },
        {
          name: "español",
          describe: "西班牙语",
          id: 7,
          value: "es",
          check: false,
        },
        {
          name: "Français",
          describe: "法语",
          id: 8,
          value: "fr",
          check: false,
        },
        {
          name: "Deutsch",
          describe: "德语",
          id: 9,
          value: "de",
          check: false,
        },
        {
          name: "Português",
          describe: "葡萄牙语",
          id: 10,
          value: "pt",
          check: false,
        },
        {
          name: "Italiano",
          describe: "意大利语",
          id: 11,
          value: "it",
          check: false,
        },
        {
          name: "Türkçe",
          describe: "土耳其语",
          id: 12,
          value: "tr",
          check: false,
        },
        {
          name: "Tiếng Việt",
          describe: "越南语",
          id: 13,
          value: "vi",
          check: false,
        },
        {
          name: "Bahasa Indonesia",
          describe: "印尼语",
          id: 14,
          value: "id",
          check: false,
        },
        {
          name: "हिन्दी",
          describe: "印地语",
          id: 15,
          value: "hi",
          check: false,
        },
        {
          name: "بالعربية",
          describe: "阿拉伯语",
          id: 16,
          value: "ar",
          check: false,
        },
        {
          name: "ภาษาไทย",
          describe: "泰语",
          id: 17,
          value: "th",
          check: false,
        }, 
        {
          name: "فارسی",
          describe: "波斯语",
          id: 18,
          value: "fa",
          check: false,
        },
      ],
      langs:[],
      drawer: false,
      direction: "btt",
      active: false,
      queryParams: "",
      detailData: {},
      env: process.env.VUE_APP_BASE_API,
      closeImage: require("@/assets/close.png"),
      fanyiImage: require("@/assets/fanyi.png"),
      shareImage: require("@/assets/share.png"),
      personImage: require("@/assets/person.png"),
      titleImage: require("@/assets/title.png"),
      offlineImage: require("@/assets/offline.png"),
      rightImage: require("@/assets/right.png"),
      iconRightImage: require("@/assets/icon-right.png"),
      scanImage: require("@/assets/scan.png"),
      iconShipinImage: require("@/assets/icon-shipin.png"),
      baseImage:require("@/assets/base.png"),
      checkedImage: require("@/assets/checked.png"),
      lang: "cn",
      test:''
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      this.getWidth();
      this.getText(this.lang);
      this.langs.forEach((item) => {
        if (item.value == val) {
          item.check = true;
        } else {
          item.check = false;
        }
      });
    },
    $route(route) {
      console.log('route',route);
    },
  },
  async mounted() {
    this.getLangs()
    if(!this.$route.query.language){
      if(localStorage.getItem("lang") ==='cn'){
        this.setLanguage()
      }
    }else{
      const val = this.$route.query.language
      this.getAppLanguage(val)
    }
    this.lang = localStorage.getItem("lang") || "cn";
    this.getWidth();
    this.getText(this.lang);
  },
  methods: {
    getAppLanguage(language){
      if (language.startsWith("zh")) {
        if(language.startsWith("zh_CN")){
          localStorage.setItem("lang", "cn");
          this.$i18n.locale = "cn";
        }
        if(language.startsWith("zh_TW")){
          localStorage.setItem("lang", "tw");
          this.$i18n.locale = "tw";
        }
        
        return
      }
      if(language.startsWith("en")){
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return
      }
      if (language.startsWith("fa")) {
        localStorage.setItem("lang", "fa");
        this.$i18n.locale = "fa";
        return
      }
    },
    getLangs(){
      this.langs=[
        {
          name: "简体中文",
          describe: this.$t('RedemptionCodePage.languages1'),
          id: 1,
          check: true,
          value: "cn",
        },
        {
          name: "繁體中文",
          describe: this.$t('RedemptionCodePage.languages2'),
          id: 2,
          check: false,
          value: "tw",
        },
        {
          name: "English",
          describe: this.$t('RedemptionCodePage.languages3'),
          id: 3,
          check: false,
          value: "en",
        },
        {
          name: "日本語",
          describe: this.$t('RedemptionCodePage.languages4'),
          id: 4,
          value: "ja",
          check: false,
        },
        {
          name: "한국어",
          describe: this.$t('RedemptionCodePage.languages5'),
          id: 5,
          value: "ko",
          check: false,
        },
        {
          name: "Русский",
          describe: this.$t('RedemptionCodePage.languages6'),
          id: 6,
          value: "ru",
          check: false,
        },
        {
          name: "español",
          describe: this.$t('RedemptionCodePage.languages7'),
          id: 7,
          value: "es",
          check: false,
        },
        {
          name: "Français",
          describe: this.$t('RedemptionCodePage.languages8'),
          id: 8,
          value: "fr",
          check: false,
        },
        {
          name: "Deutsch",
          describe: this.$t('RedemptionCodePage.languages9'),
          id: 9,
          value: "de",
          check: false,
        },
        {
          name: "Português",
          describe: this.$t('RedemptionCodePage.languages10'),
          id: 10,
          value: "pt",
          check: false,
        },
        {
          name: "Italiano",
          describe: this.$t('RedemptionCodePage.languages11'),
          id: 11,
          value: "it",
          check: false,
        },
        {
          name: "Türkçe",
          describe: this.$t('RedemptionCodePage.languages12'),
          id: 12,
          value: "tr",
          check: false,
        },
        {
          name: "Tiếng Việt",
          describe: this.$t('RedemptionCodePage.languages13'),
          id: 13,
          value: "vi",
          check: false,
        },
        {
          name: "Bahasa Indonesia",
          describe: this.$t('RedemptionCodePage.languages14'),
          id: 14,
          value: "id",
          check: false,
        },
        {
          name: "हिन्दी",
          describe: this.$t('RedemptionCodePage.languages15'),
          id: 15,
          value: "hi",
          check: false,
        },
        {
          name: "بالعربية",
          describe: this.$t('RedemptionCodePage.languages16'),
          id: 16,
          value: "ar",
          check: false,
        },
        {
          name: "ภาษาไทย",
          describe: this.$t('RedemptionCodePage.languages17'),
          id: 17,
          value: "th",
          check: false,
        },
        {
          name: "فارسی",
          describe: this.$t('RedemptionCodePage.languages18'),
          id: 18,
          value: "fa",
          check: false,
        },
      ]
    },
    setLanguage() {
      this.getWidth()
      let language = this.getPreferredLanguage();
      if (language.startsWith("zh")) {
        localStorage.setItem("lang", "cn");
        this.$i18n.locale = "cn";
        return
      }
      if(language.startsWith("en")){
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return
      }
      if (language.startsWith("fa")) {
        localStorage.setItem("lang", "fa");
        this.$i18n.locale = "fa";
        return
      }
      
    },
    getPreferredLanguage(){
      return navigator.language || navigator.userLanguage;
    },
    hanldeUserCodes() {
      this.isLogin = getToken();
      if (!this.isLogin) {
        this.$router.push({
          path: "/login",
        });
        return;
      }
      this.$router.push({
        path: "/RedemptionList",
      });
    },
    getText(val) {
      const list = {
        cn: "CN",
        tw: "TW",
        en: "EN",
        ja: "JP",
        ko: "KR",
        ru: "RU",
        es: "ES",
        fr: "FR",
        de: "DE",
        pt: "PT",
        it: "IT",
        tr: "TR",
        vi: "VN",
        id: "ID",
        hi: "IN",
        ar: "AE",
        th: "TH",
        fa: "FA",
      };
      this.langText = list[val];
    },
    getWidth() {
      this.serviceHeight =  'calc(100% - 362px)'
      if (this.lang == "cn" || this.lang == "tw") {
        this.width1 = "88px";
        this.height1 = "220px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
      if (this.lang == "ja") {
        this.width1 = "100px";
        this.height1 = "220px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
      if (this.lang == "en") {
        this.width1 = "135px";
        this.height1 = "230px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
      if (this.lang == "es") {
        this.width1 = "118px";
        this.height1 = "270px";
        this.height2 = "176px";
        this.height3 = "160px";
        this.height4 = "157px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "ru") {
        this.width1 = "118px";
        this.height1 = "270px";
        this.height2 = "152px";
        this.height3 = "156px";
        this.height4 = "154px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "fr") {
        this.height1 = "270px";
        this.width1 = "160px";
        this.height2 = "173px";
        this.height3 = "156px";
        this.height4 = "136px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "de") {
        this.width1 = "108px";
        this.height1 = "240px";
        this.height2 = "176px";
        this.height3 = "140px";
        this.height4 = "160px";
        this.serviceHeight =  'calc(100% - 375px)'
      }
      if (this.lang == "pt") {
        this.height1 = "270px";
        this.width1 = "112px";
        this.height2 = "152px";
        this.height3 = "158px";
        this.height4 = "136px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "it") {
        this.height1 = "270px";
        this.height2 = "136px";
        this.height3 = "156px";
        this.height4 = "136px";
        this.width1 = "116px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "tr" || this.lang == "id") {
        this.width1 = "88px";
        this.height1 = "270px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if (this.lang == "vi") {
        this.width1 = "88px";
        this.height1 = "236px";
        this.height2 = "136px";
        this.height3 = "160px";
        this.height4 = "136px";
        this.serviceHeight =  'calc(100% - 375px)'
      }
      if (this.lang == "id") {
        this.width1 = "128px";
        this.height1 = "270px";
        this.height2 = "158px";
        this.height3 = "160px";
        this.height4 = "136px";
        this.serviceHeight =  'calc(100% - 405px)'
      }
      if(this.lang == "ar"){
        this.width1 = "128px";
        this.height1 = "220px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
      if (this.lang == "hi") {
        this.width1 = "88px";
        this.height1 = "220px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
      if (this.lang == "th") {
        this.width1 = "118px";
        this.height1 = "220px";
        this.height2 = "136px";
        this.height3 = "136px";
        this.height4 = "136px";
      }
    },
    handleLanguage() {
      this.drawer = true;
    },
    handleItem(val) {
      this.isLogin = getToken();
      if (!this.isLogin) {
        this.$router.push({
          path: "/login",
        });
        return;
      }
      if (val === "fanyi") {
        this.$router.push({
          path: "/OffLinePage",
        });
      }
      if (val === "video") {
        this.$router.push({
          path: "/AudioVideoPage",
        });
      }
      if (val === "base") {
        this.$router.push({
          path: "/basePage",
        });
      }
    },
    handleClose(done) {
      done();
    },
    setLang(val) {
      this.langs.forEach((item) => {
        if (item.name == val.name) {
          item.check = true;
          localStorage.setItem("lang", val.value);
          this.lang = localStorage.getItem("lang");
          this.$i18n.locale = val.value;
        } else {
          item.check = false;
        }
      });
      this.getLangs()
      this.drawer = false
    },
    goBack() {
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  overflow: hidden;
  padding:0px 16px
}
.appHeader{
  position: fixed;
  top: 0px;
  left:0px;
  width: calc(100% - 32px);
  background-color: #f5f5f5;
  padding:0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
  position: relative;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.fanyi-img {
  width: 18px;
  height: 18px;
  line-height: 16px;
  float: right;
  /* padding-top: 10px; */
  /* margin: 10px 16px 0px 0px; */
  cursor: pointer;
  border: 2px solid #201f34;
  font-size: 12px;
  margin-top: 10px;
}
.share-img {
  width: 24px;
  height: 24px;
  float: right;
  padding-top: 10px;
  cursor: pointer;
}
.title-left {
  float: left;
  font-family: Alimama ShuHeiTi;
  font-size: 24px;
  font-weight: bold;
  line-height: 36px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding-top: 16px;
  max-width: 274px;
}
.describe {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  margin-top: 4px;
}
.title-right {
  float: right;
}
.person-img {
  width: 40px;
  height: 40px;
  margin-top: 16px;
}
.title {
  min-height: 80px;
  margin-top: 44px;

}
.tip {
  height: 240px;
}
.title-img {
  height: 240px;
  margin: -8px 0px 0px -16px;
}
.fanyi-service {
  width: 100%;
  height: 136px;
  border-radius: 16px;
  background: #e5e5e7;
  /* padding-bottom: 16px; */
}
.fanyi-service-left {
  float: left;
}
.item1 {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding: 16px 16px 8px 16px;
  max-width: 245px;
  box-sizing: border-box;
}
.offline-img {
  width: 32px;
  height: 32px;
  padding-right: 8px;
  vertical-align: middle;
}
.item2 {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  padding-left: 16px;
  max-width: 238px;
  min-height: 32px;
}
.item3 {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  margin: 5px 0px 0px 16px;

  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
  padding-left: 12px;
  cursor: pointer;
}
.item4 {
  width: 135px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  margin: 5px 0px 0px 16px;

  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
  padding-left: 12px;
  cursor: pointer;
}
.right-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.fanyi-service-right {
  float: right;
  margin-right: 16px;
}
.icon-right-img {
  width: 16px;
  height: 16px;
}
.right-item1 {
  margin: 22px 0px 32px 32px;
  cursor: pointer;
}
.scan-img {
  width: 50px;
  height: 50px;
}
.video-service {
  width: 100%;
  height: 136px;
  border-radius: 16px;
  background: #d0eafc;
  margin-top: 8px;
}
.base-service {
  width: 100%;
  height: 136px;
  border-radius: 16px;
  /* margin-top: 24px; */
  background: #ffe6e1;
  margin-top: 8px;
}
.isActive {
  background: #d0eafc;
}
.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.drawer-item {
  padding: 0px 16px;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
}
.drawer-content {
  display: flex;
  height: 20px;
  line-height: 20px;
  padding: 14px 16px;
}
.checked-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.item-left {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #201f34;
  padding: 0px 5px;
}
.item-right {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #8e8e8e;
}
.drawer >>> .el-drawer__body {
  padding: 0px 16px;
  margin-top: -10px;
}
</style>
  